/* eslint-disable max-len */
import { connect } from 'react-redux';
import _map from 'lodash/map';
import _replace from 'lodash/replace';
import _toLower from 'lodash/toLower';
import Configurator from './Configurator';
import { loadShapes, persistedShapeInfo, loadPersistedShapes, updateInitialLoad } from '../../actions/draftingToolActions';
import reRenderPropCheck from '../../utils/reRenderPropCheck';
import {
  getDesignByItem, addItemProduct, saveFailed,
} from '../../actions/designActions';
import {
  disableSave, enableSave,
} from '../../actions/saveActions';
import { getProductDetails, togglePlccModal } from '../../actions/Products';
// import configKeys from '../../config';
// import { Utils } from '../../utils/urlUtils';

/* const {
  env,
} = configKeys; */

export const mapStateToProps = (state, ownProps) => {
  const { omsId } = ownProps.match;
  let productName = '';
  let brand = '';
  const { productInfo } = state.configurator;
  if (productInfo && productInfo.productName) {
    ({ productName } = productInfo);
  } else {
    const product = state.products.currentProducts[+omsId];
    if (product) {
      productName = product?.ProductName;
      brand = product?.Brand;
    }
  }

  // const { thdBreadcrumbs } = configKeys;

  /*   const breadcrumbs = thdBreadcrumbs && _map(thdBreadcrumbs, (obj) => ({ label: obj.name, link: obj.url }));
  breadcrumbs[breadcrumbs?.length] = {
    label: productName,
    link: Utils.containsNucleusPath()
      ? `/render-nucleus/p/${_toLower(_replace(_replace(productName, 'Countertop', ''), /\s/g, ''))}/${omsId}${env.search}`
      : `/p/${_toLower(_replace(_replace(productName, 'Countertop', ''), /\s/g, ''))}/${omsId}`,
  }; */

  const {
    configurator: {
      choices
    },
    countertops: {
      selectedSku,
      availableSkus,
      selectedColor,
      isProductAvailable,
    } = {},
    design: {
      currentItem,
      designAssociated,
      status,
    },
    store: {
      storeNumber,
      isStoreEnabled,
      storeInfo,
    },
    draftingTool,
  } = state;

  const { isLoading } = state.configurator.ajaxStatus;
  const { areaChanged, initialLoad } = draftingTool;
  const currentColor = selectedColor && selectedColor.name;
  const colorAvailable = state.configurator.pricing.pricing.price;
  const selectedColorPrice = choices[selectedColor?.id]?.calculatedPrice;
  const selectionAvailable = colorAvailable !== 0;
  const { pcpSupportPhoneNumber } = state.config;

  return ({
    sku: selectedSku,
    availableSkus,
    draftingTool,
    selectedColor,
    areaChanged,
    isLoading,
    choices,
    priceLoading: !state.configurator.ajaxStatus.priceLoading,
    currentItem,
    currentDesignId: state.design?.currentDesign?.designId,
    hasQuote: status && status.orders
      ? status.orders.some((oo) => oo.orderNbr)
      : false,
    isConfiguratorLoading: !state.configurator.ajaxStatus.isInitialized
        && isProductAvailable !== false
        && isStoreEnabled !== false,
    storeNumber,
    storeInfo,
    currentProducts: state.products.currentProducts,
    isProductAvailable,
    initialLoad,
    productName,
    brand,
    // breadcrumbs,
    savedProductChoices: state.configurator.savedProductChoices,
    isStoreEnabled,
    isSaving: !!(state.design && state.design.isSaving),
    configurationImageUrl: selectedColor && (selectedColor.imageUrl || selectedColor.mediaUrl),
    designAssociated,
    isSelectionAvailable: selectionAvailable,
    currentColor,
    pcpSupportPhoneNumber,
    price: state.configurator.pricing.pricing,
    showModal: state.products.showPlccModal,
    togglePlccModal,
    selectedColorPrice,
    config: ownProps?.config,
    countertopsBaseUrl: ownProps?.countertopsBaseUrl,
  }
  );
};

const mapDispatchToProps = {
  onLoadSuccess: loadShapes,
  onSaveSuccess: addItemProduct,
  persistedShapeInfo,
  loadPersistedShapes,
  getProductDetails,
  getDesignByItem,
  disableSave,
  enableSave,
  saveFailed,
  togglePlccModal,
  updateInitialLoad
};

export default connect(mapStateToProps, mapDispatchToProps, null, reRenderPropCheck)(Configurator);
